import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class FactorSetupGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var factorSetupGrid = this;
		setTimeout(function(){
			factorSetupGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var factorSetupGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},				
				{
					tag: 'vaadin-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true				
			},			
			children: [	
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'productCode',
					header: 'Product Key',					
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.productCode + '-' + rowData.item.featureProductCode;
					}
				},				
				{						
					path: 'featureName',
					header: 'Description',					
					'flex-grow': '1'					
				},
				{						
					path: 'initalFactorCount',
					header: 'Count',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'overrideFlag',
					header: 'Override Flag',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',										
					width: '9em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',										
					width: '9em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);	
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		factorSetupGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {

			var loadMask = factorSetupGrid.showLoading();
			BillingService.getAccountService().getAccountFactorSetup(factorSetupGrid.detail.companyId)
			.then(function(factors){							
				loadMask.remove();
				grid.activeItem = null;					
				
				grid.items = factors;
			});			
					
		};
		actionRefresh();

		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: (record ? 'Edit' :  'Add') + ' Factoring',
				icon: 'lumo:edit',
				width: 800,
				height: 275,
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [									
										{
											tag: 'vaadin-combo-box',											
											itemid: 'productItem',
											label: 'Product Item', 
											name: 'productItem',
											required: true,											
											'item-value-path': 'code',
											'item-label-path': 'itemDesc',
											postinit: function(combo) {

												Promise.all([
													BillingService.getProductService().getEffectiveProductItems('ADDITIONAL'),
													BillingService.getAccountService().getOrders(factorSetupGrid.detail.companyId)
												]).then(function(results) {
													var data = results[0];
													var orders = results[1];

													var companyProductCodes = {};
													orders.forEach(function(orderFull) {
														orderFull.items.forEach(function(itemFull) {
															var code = itemFull.item.productCode + '-' + itemFull.item.featureProductCode;
															companyProductCodes[code] = true;
														});
													});

													var companyHas = [];
													var companyLacks = [];
													data.forEach(function(item) {
														var productItem = item.productItem;
														productItem.code = productItem.productItemPK.productCode + '-' + productItem.productItemPK.featureProductCode;
														if (companyProductCodes[productItem.code]) {
															companyHas.push(productItem);
														} else {
															companyLacks.push(productItem);
														}
													});

													var sortByDescription = function(a, b) {
														return a.itemDesc.localeCompare(b.itemDesc);
													};
													companyHas.sort(sortByDescription);
													companyLacks.sort(sortByDescription);

													var productItems = companyHas.slice();
													if (companyHas.length > 0 && companyLacks.length > 0) {
														productItems.push({
															code: '__SEPARATOR__',
															itemDesc: '────────────────',
															disabled: true
														});
													}
													productItems = productItems.concat(companyLacks);

													combo.itemDisabledPath = 'disabled';
													combo.items = productItems;
												});
											}
										},
										{
											tag: 'vaadin-number-field',
											label: 'Factor Count',
											name: 'initalFactorCount',
											required: true,
											min: 0,
											max: 9999999
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'overrideFlag',
											label: 'Override'										
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {
															var productItemCB = ElementUtil.query(formPanel, 'productItem');
															var productItemValue = productItemCB.selectedItem;
															if (!productItemValue || productItemValue.disabled || !productItemValue.productItemPK) {
																return;
															}

															formPanel.submitForm({
																preSubmit: function(data) {
																	data = Object.assign({},{																		
																		productCode: productItemValue.productItemPK.productCode,
																		featureProductCode: productItemValue.productItemPK.featureProductCode
																	}, data);
																	
																	if (!data.overrideFlag) {
																		data.overrideFlag = false;
																	}
																	if (record) {
																		data.factorSetupId = record.factorSetupId;
																	}
																	data.companyId = factorSetupGrid.detail.companyId;
																	
																	return data;
																},
																actualCall: function(data) {
																	return BillingService.getAccountService().saveFactorSetup(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Factoring', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							
							record.productItem = record.productCode + '-' + record.featureProductCode;							
							formPanel.load(record);							
						}
						
					}
				}
			});
		
						
		};
		
		var actionDelete = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.companyName + " - " + record.productName, 40);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + summary + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');													
							
							BillingService.getAccountService().deleteFactorSetup(record.factorSetupId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-account-factoring-grid', FactorSetupGrid);